import { useI18n } from '@change-corgi/core/react/i18n';

import { usePromotePageData, usePromotePageState } from 'src/app/pages/promote/pageContext';
import { useIsSecureGuest } from 'src/app/shared/hooks/payments';

import { useShouldHideForExperiment } from '../useShouldHideForExperiment';

type Result = ModelHookResult<
	{
		displayed: boolean;
		shouldSavePaymentMethod: boolean;
		label: string;
	},
	{ setShouldSavePaymentMethod: (shouldSavePaymentMethod: boolean) => void }
>;

export function useShouldSavePaymentMethodInput(): Result {
	const [
		{
			paymentMethodSaveOptions: { shouldSavePaymentMethod },
		},
		{ setShouldSavePaymentMethod },
	] = usePromotePageState();

	const {
		data: {
			featureConfigs: { doubleOptinEnabledNewUser },
		},
	} = usePromotePageData();
	const isSecureGuest = useIsSecureGuest(doubleOptinEnabledNewUser);

	const { translate } = useI18n();

	const shouldHideForExperiment = useShouldHideForExperiment();

	return {
		data: {
			displayed: !isSecureGuest && !shouldHideForExperiment,
			shouldSavePaymentMethod,
			label: translate('corgi.co.promote.save_payment_info'),
		},
		actions: {
			setShouldSavePaymentMethod,
		},
	};
}
